// Generated from @cascade/api-contracts. Do not edit.
// Run: pnpm --filter @cascade/api-client build

import type {
  TApiRequestOptions,
  TApiTransport,
} from '#request/request.types.ts';
import type {
  TGetKnockTokenRequestPayload,
  TGetKnockTokenResponsePayload,
} from './notifications.types.ts';

export const createNotificationsApi = (transport: TApiTransport) => ({
  /** Issues a notifications (Knock) client token */
  getKnockToken: (
    payload: TGetKnockTokenRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<TGetKnockTokenRequestPayload, TGetKnockTokenResponsePayload>(
      '/get_knock_token',
      payload,
      options,
    ),
});
